/* =========================================================================
   dko-motion.js  ·  Motor de movimiento para DKo Home (base Horizon 4.1.3)
   -------------------------------------------------------------------------
   1. Etiqueta solo las secciones y dispara reveals con IntersectionObserver.
   2. Parte titulares en palabras para que suban escalonadas.
   3. Convierte las tarjetas de categoria en tarjetas con pie deslizante.
   4. Mueve las cintas marquee, con empuje del scroll.
   5. Marca el header en scroll y calcula parallax acotado.

   DECISIONES
   - El estado invisible solo se aplica si este script corrio. Si falla o lo
     bloquean, la pagina se ve entera.
   - Se excluye el interior de carruseles del reveal: sus slides estan fuera
     del viewport horizontalmente y el observer no dispararia nunca.
   - La primera seccion no se anima: es el LCP.
   - ZONA TRANSACCIONAL (14/09): ninguna seccion que contenga un formulario
     de agregar al carrito se anima. Quien llega a una ficha desde un anuncio
     no debe ver aparecer el boton de compra. Se detecta por el formulario,
     no por el nombre de la seccion, asi aplica a cualquier plantilla.
   - Los marquee y el parallax solo corren cuando estan en pantalla.

   NOMBRES RESERVADOS: el atributo data-dko-reveal es del motor. No usarlo en
   secciones propias para otra cosa (paso el 14/09 con el hero: quedo
   invisible). Para saltar una seccion completa: data-dko-skip.
   AUTOR: implementacion propia.
   ========================================================================= */

(function () {
  'use strict';

  var CONFIG = {
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.12,
    skipFirstSections: 1,
    staggerMs: 90,
    staggerCap: 5,
    wordStaggerMs: 45,
    maxWords: 24,
    maxHeadingChars: 120,
    catCaptionMaxChars: 34,
    parallaxMaxPx: 40,
    headerScrollPx: 40,
    /* Empuje del scroll en VECES la velocidad normal de la cinta (24/09/2026). Antes eran px/s fijos
       (14 por px de scroll, tope 2600 = 48 veces la normal) y en movil un scroll corto la llevaba a
       6-11 pantallas por segundo. Ahora un scroll suave la lleva a ~2x, el tope es 3x y al subir, como
       mucho, se devuelve a velocidad normal. */
    scrollBoostGain: 0.01,
    scrollBoostMax: 2,
    scrollBoostDecay: 0.12,
    marqueeMaxTracks: 12
  };

  var CAROUSEL_GUARD = 'slideshow-component, slideshow-slides, slideshow-slide, .carousel, marquee-component, .dko-marquee, [data-dko-skip]';

  /* Secciones que nunca se animan: las que venden. */
  var TRANSACTIONAL = 'product-form-component, form[action*="/cart/add"], .product-information, product-information';

  var TARGET_SELECTORS = [
    '.product-grid > li',
    '.group-block > .text-block, .group-block > .image-block',
    '.text-block, .image-block, .button-block, .email-signup-block'
  ];

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;
  var parallaxNodes = [];
  var ticking = false;

  function insideCarousel(el, section) {
    var node = el.parentElement;
    while (node && node !== section) {
      if (node.matches && node.matches(CAROUSEL_GUARD)) return true;
      node = node.parentElement;
    }
    return false;
  }

  function isMedia(el) {
    return el.matches('img, picture, video, .image-block, .media, [class*="image-block"]');
  }

  function pickTargets(section) {
    for (var i = 0; i < TARGET_SELECTORS.length; i++) {
      var found = Array.prototype.filter.call(
        section.querySelectorAll(TARGET_SELECTORS[i]),
        function (el) { return !insideCarousel(el, section); }
      );
      if (found.length >= 2) return found;
    }
    return [section];
  }

  function eligibleHeading(el) {
    var h = el.matches && el.matches('h1, h2, h3, h4')
      ? el
      : el.querySelector && el.querySelector('h1, h2, h3, h4');
    if (!h || h.dataset.dkoSplit === '1') return null;
    if (h.querySelector('a, img, svg, br, span')) return null;
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    if (!text || text.length > CONFIG.maxHeadingChars) return null;
    if (text.split(' ').length > CONFIG.maxWords) return null;
    return h;
  }

  function splitWords(h) {
    var words = h.textContent.replace(/\s+/g, ' ').trim().split(' ');
    var keepStrong = !!h.querySelector('strong');
    var frag = document.createDocumentFragment();

    words.forEach(function (word, i) {
      var outer = document.createElement('span');
      outer.className = 'dko-word';
      var inner = document.createElement('span');
      inner.className = 'dko-word__i';
      inner.textContent = word;
      inner.style.setProperty('--dko-delay', (i * CONFIG.wordStaggerMs) + 'ms');
      outer.appendChild(inner);
      frag.appendChild(outer);
      if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
    });

    h.textContent = '';
    if (keepStrong) {
      var strong = document.createElement('strong');
      strong.appendChild(frag);
      h.appendChild(strong);
    } else {
      h.appendChild(frag);
    }
    h.dataset.dkoSplit = '1';
    return true;
  }

  function enhanceCategoryCards(root) {
    var cards = (root || document).querySelectorAll('.card[data-carousel-card]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.dkoCat === '1') return;
      var inner = card.querySelector('.card__inner');
      if (!inner || !inner.classList.contains('layout-panel-flex--column')) return;
      var image = inner.querySelector(':scope > .image-block');
      var text = inner.querySelector(':scope > .text-block');
      if (!image || !text) return;
      var label = text.textContent.replace(/\s+/g, ' ').trim();
      if (!label || label.length > CONFIG.catCaptionMaxChars) return;
      card.dataset.dkoCat = '1';
      card.classList.add('dko-cat-card');
    });
  }

  /* -------------------------------------------------------------------------
     CUANTAS PISTAS HACEN FALTA  · corregido 21/09/2026

     El ciclo desplaza el ancho de UNA pista y confia en que la siguiente ya
     ocupe el hueco. Para que nunca quede vacio a la derecha, el contenido
     total tiene que superar el ancho visible en al menos una pista:

         n >= anchoVisible / anchoPista + 1

     La plantilla emite 2 pistas, que alcanza solo si cada una es mas ancha
     que la pantalla. Con los tres mensajes de pago la pista mide ~950px: en
     movil sobra, en escritorio de 1440+ faltaba casi media pantalla y en cada
     vuelta aparecia un hueco. Se leia como que la cinta se cortaba.

     Aqui se clonan las que falten y se recalcula al cambiar el tamano de la
     ventana. El tope de marqueeMaxTracks es un seguro: si por CSS la pista
     midiera casi cero, el bucle no debe llenar el DOM.

     Los clones van con aria-hidden (el lector de pantalla ya leyo la pista 1)
     y sin los atributos del editor, para que Shopify no crea que hay varios
     bloques donde hay uno. A los enlaces clonados se les quita el foco por
     teclado: se veria el mismo enlace tres veces en el recorrido del tab.
     ------------------------------------------------------------------------- */
  function fillTracks(root, inner, track) {
    var width = track.offsetWidth;
    var visible = root.offsetWidth;
    if (!width || !visible) return;

    var needed = Math.min(Math.ceil(visible / width) + 1, CONFIG.marqueeMaxTracks);
    var clones = Array.prototype.slice.call(
      inner.querySelectorAll('.dko-marquee__track[data-dko-clone="1"]')
    );
    var total = inner.querySelectorAll('.dko-marquee__track').length;

    while (total > needed && clones.length) {
      inner.removeChild(clones.pop());
      total--;
    }

    while (total < needed) {
      var copy = track.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-dko-clone', '1');
      Array.prototype.forEach.call(copy.querySelectorAll('[data-shopify-editor-block]'), function (n) {
        n.removeAttribute('data-shopify-editor-block');
      });
      Array.prototype.forEach.call(copy.querySelectorAll('a'), function (n) {
        n.setAttribute('tabindex', '-1');
      });
      inner.appendChild(copy);
      total++;
    }
  }

  function initMarquee(root) {
    if (root.dataset.dkoMarquee === '1') return;
    var inner = root.querySelector('.dko-marquee__inner');
    var track = root.querySelector('.dko-marquee__track');
    if (!inner || !track) return;
    if (reduced.matches) return;

    root.dataset.dkoMarquee = '1';
    root.dataset.dkoJs = '1';

    var seconds  = parseFloat(root.dataset.dkoSpeed) || 34;
    var dir      = root.dataset.dkoDirection === 'right' ? -1 : 1;
    var reactive = root.dataset.dkoReactive === '1';

    var offset = 0, boost = 0, last = 0, lastY = window.scrollY;
    var running = false, hovering = false, resizeTick = false;

    fillTracks(root, inner, track);

    window.addEventListener('resize', function () {
      if (resizeTick) return;
      resizeTick = true;
      window.requestAnimationFrame(function () {
        resizeTick = false;
        fillTracks(root, inner, track);
      });
    }, { passive: true });

    root.addEventListener('pointerenter', function () { hovering = true; });
    root.addEventListener('pointerleave', function () { hovering = false; });

    function frame(now) {
      if (!running) return;
      if (!last) last = now;
      var dt = Math.min(now - last, 64) / 1000;
      last = now;
      var width = track.offsetWidth;
      if (width > 0) {
        var cruise = width / seconds;
        var base = hovering ? 0 : cruise;
        if (reactive) {
          /* ponytail: window.scrollY solo se mueve bajo 990px. Desde ahi Horizon hace scroll dentro de
             .page-wrapper y scrollY queda en 0: en escritorio la cinta no se empuja. Para empujarla
             tambien ahi, leer el scrollTop de .page-wrapper. */
          var y = window.scrollY;
          var cap = CONFIG.scrollBoostMax * cruise;
          boost += (y - lastY) * CONFIG.scrollBoostGain * cruise;
          lastY = y;
          boost *= Math.pow(CONFIG.scrollBoostDecay, dt);
          if (boost > cap) boost = cap;
          if (boost < -cap) boost = -cap;
        }
        offset += (base + boost) * dir * dt;
        offset = ((offset % width) + width) % width;
        inner.style.transform = 'translate3d(' + (-offset).toFixed(2) + 'px, 0, 0)';
      }
      window.requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      running = true;
      window.requestAnimationFrame(frame);
      return;
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !running) {
          running = true; last = 0; lastY = window.scrollY;
          window.requestAnimationFrame(frame);
        } else if (!entry.isIntersecting) {
          running = false;
        }
      });
    }, { threshold: 0 }).observe(root);
  }

  function initMarquees(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.dko-marquee'), initMarquee);
  }

  function tagSections(scope) {
    var main = document.getElementById('MainContent');
    if (!main) return [];

    var sections = Array.prototype.slice.call(main.children).filter(function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });

    var tagged = [];

    sections.forEach(function (section, index) {
      if (scope && scope !== section && !section.contains(scope)) return;
      if (index < CONFIG.skipFirstSections) return;
      if (section.hasAttribute('data-dko-skip')) return;
      if (section.querySelector(TRANSACTIONAL)) return;          /* zona de compra: quieta */
      if (section.dataset.dkoTagged === '1') return;
      section.dataset.dkoTagged = '1';

      pickTargets(section).forEach(function (el, i) {
        if (el.hasAttribute('data-dko-reveal')) return;
        var heading = reduced.matches ? null : eligibleHeading(el);
        var mode;
        if (heading && splitWords(heading)) {
          mode = 'text';
        } else {
          mode = isMedia(el) ? 'wipe' : 'up';
          el.style.setProperty('--dko-delay', (Math.min(i, CONFIG.staggerCap) * CONFIG.staggerMs) + 'ms');
        }
        el.setAttribute('data-dko-reveal', mode);
        tagged.push(el);
      });
    });

    return tagged;
  }

  function reveal(el) { el.classList.add('dko-in'); }

  function observe(nodes) {
    if (!observer) return nodes.forEach(reveal);
    nodes.forEach(function (el) {
      if (el.dataset.dkoObserved === '1') return;
      el.dataset.dkoObserved = '1';
      observer.observe(el);
    });
  }

  function buildObserver() {
    if (!('IntersectionObserver' in window)) return null;
    return new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        obs.unobserve(entry.target);
      });
    }, { rootMargin: CONFIG.rootMargin, threshold: CONFIG.threshold });
  }

  function collectParallax() {
    parallaxNodes = Array.prototype.slice.call(document.querySelectorAll('[data-dko-parallax]'));
  }

  function onFrame() {
    ticking = false;
    document.body.classList.toggle('dko-scrolled', window.scrollY > CONFIG.headerScrollPx);
    if (reduced.matches || !parallaxNodes.length) return;
    var vh = window.innerHeight;
    parallaxNodes.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var depth = parseFloat(el.getAttribute('data-dko-parallax')) || 0.25;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      var shift = Math.max(-1, Math.min(1, progress)) * CONFIG.parallaxMaxPx * depth;
      el.style.setProperty('--dko-parallax-y', shift.toFixed(2) + 'px');
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onFrame);
  }

  function init() {
    document.documentElement.classList.add('dko-motion-ready');
    if (reduced.matches) {
      tagSections().forEach(reveal);
    } else {
      observer = buildObserver();
      observe(tagSections());
    }
    enhanceCategoryCards();
    initMarquees();
    collectParallax();
    onFrame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section && section.dataset) delete section.dataset.dkoTagged;
    var nodes = tagSections(section);
    if (reduced.matches) { nodes.forEach(reveal); } else { observe(nodes); }
    enhanceCategoryCards(section);
    initMarquees(section);
    collectParallax();
    onFrame();
  });

  if (reduced.addEventListener) {
    reduced.addEventListener('change', function () {
      if (!reduced.matches) return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-dko-reveal]'), reveal);
    });
  }
})();
